import React, { Component } from 'react';
import '../../css/modal.scss';
import { connect } from 'react-redux';
import { comma } from '../../lib/util/numberUtil';
import { Modal } from 'antd';
import {
  addPosOrder,
  removePosOrder,
  removePosOrderAll,
} from '../../actions/posAction';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { paymentMethodString, modalStyle } from '../../lib/util/codeUtil';
import image from '../../res/image';

class PosOrderModal extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  removeAll = () => {
    const self = this;
    Modal.confirm({
      ...modalStyle,
      content:
        'POS에서 들어온 주문목록을 전부 삭제하시겠습니까? 한번 삭제하는 경우 다시 불러올 수 없습니다.',
      okText: '확인',
      cancelText: '취소',
      onOk() {
        self.props.removePosOrderAll();
      },
      onCancel() {},
    });
  };
  remove = (idx) => {
    const self = this;
    Modal.confirm({
      ...modalStyle,
      content: '주문을 삭제하시겠습니까?',
      okText: '확인',
      cancelText: '취소',
      onOk() {
        self.props.removePosOrder(idx);
      },
      onCancel() {},
    });
  };

  render() {
    const { isOpen, close } = this.props;
    return (
      <React.Fragment>
        {isOpen ? (
          <React.Fragment>
            <div className="Modal-overlay" onClick={close} />
            <div className="Modal-wide">
              <div className="pw-title">POS주문 목록</div>
              <div className="pw-image" onClick={close}>
                <img style={{ display: 'inline' }} src={image.closeIcon} alt="" />
              </div>
              <div className="posorder-content">
                <div className="posorder-element-all">
                  <div className="posorder-element-block">
                    <div className="posorder-element-block-menu">
                      <div className="posorder-element-block-menu-text1">
                        주문시간
                      </div>
                      <div className="posorder-element-block-menu-text2">
                        고객정보
                      </div>
                      <div className="posorder-element-block-menu-text1">
                        상품가액
                      </div>
                      <div className="posorder-element-block-menu-text3 mobileoff">
                        선택
                      </div>
                      <div className="posorder-element-block-menu-text3 mobileoff">
                        삭제
                      </div>
                    </div>
                  </div>
                  {/* 기본 */}
                  <div className="posorder-element-block-field-wrapper mobileoff">
                    {(!this.props.posReducer.posOrders ||
                      this.props.posReducer.posOrders.length) === 0 && (
                      <div style={{ textAlign: 'center', padding: '50px' }}>
                        내역이 없습니다.
                      </div>
                    )}
                    {this.props.posReducer.posOrders.map((row, index) => {
                      return (
                        <div
                          key={index}
                          className="posorder-element-block-field">
                          <div className="posorder-element-block-field-text1">
                            {row.orderDate}
                          </div>
                          <div className="posorder-element-block-field-text2">
                            {row.destAddr1}
                            <div className="posorder-element-block-field-text2-sub">
                              {row.custPhone}
                            </div>
                          </div>
                          <div className="posorder-element-block-field-text1">
                            {paymentMethodString[row.paymentMethod]}
                            <div className="posorder-element-block-field-text2-sub">
                              {comma(row.orderPrice)}원
                            </div>
                          </div>

                          <div className="posorder-element-block-field-text3">
                            <div
                              className="posorder-element-block-field-btn1"
                              onClick={() => {
                                this.props.close();
                                if (
                                  typeof this.props.onSelect === `undefined`
                                ) {
                                  this.props.history.push({
                                    pathname: '/main',
                                    state: row,
                                  });
                                } else {
                                  this.props.onSelect(row);
                                }
                              }}>
                              선택
                            </div>
                          </div>

                          <div className="posorder-element-block-field-text3">
                            <div
                              className="posorder-element-block-field-btn2"
                              onClick={() => this.remove(row.idx)}>
                              삭제
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                  {/* 모바일버전 */}
                  <div className="posorder-element-block-field-wrapper mobile">
                    {(!this.props.posReducer.posOrders ||
                      this.props.posReducer.posOrders.length) === 0 && (
                      <div style={{ textAlign: 'center', padding: '50px' }}>
                        내역이 없습니다.
                      </div>
                    )}
                    {this.props.posReducer.posOrders.map((row, index) => {
                      return (
                        <div
                          key={index}
                          className="posorder-element-block-field">
                          <div
                            onClick={() => {
                              this.props.close();
                              if (typeof this.props.onSelect === `undefined`) {
                                this.props.history.push({
                                  pathname: '/main',
                                  state: row,
                                });
                              } else {
                                this.props.onSelect(row);
                              }
                            }}>
                            <div className="posorder-element-block-field-text1">
                              {row.orderDate}
                            </div>
                            <div className="posorder-element-block-field-text2">
                              {row.destAddr1}
                              <div className="posorder-element-block-field-text2-sub">
                                {row.custPhone}
                              </div>
                            </div>
                            <div className="posorder-element-block-field-text1">
                              {comma(row.orderPrice)}원
                            </div>
                          </div>
                          <div
                            className="posorder-element-block-field-btn2"
                            onClick={() => this.remove(row.idx)}>
                            삭제
                          </div>
                        </div>
                      );
                    })}
                  </div>
                  {/* 모바일버전 끝 */}
                </div>
                <div className="posorder-btn-wrapper">
                  <div className="posorder-btn-delete" onClick={this.removeAll}>
                    전체삭제
                  </div>
                </div>
              </div>
            </div>
          </React.Fragment>
        ) : null}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  const { loginReducer, posReducer } = state;
  return { loginReducer, posReducer };
};
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    { addPosOrder, removePosOrder, removePosOrderAll },
    dispatch
  );

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(PosOrderModal)
);
